import axios from 'axios'
import { getAuthHeader } from '../../utils';

export const v2_gates = async (warehouseId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/gate/${warehouseId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
